import { Injectable } from '@angular/core';

import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SideServiceService {

 //readonly rootURL = 'https://localhost:5001/api';
readonly rootURL = 'https://app-mnb-api.yellowtree-8c854e2d.canadacentral.azurecontainerapps.io/api';
  constructor(private http: HttpClient) { }

  getCatCounts() {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");

    var url = this.rootURL + '/Generic/GetCatCounts';
    var ret = this.http.get<any>(url);
    return ret;

  }
  getRecentPosts() {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    headers.append("access-control-allow-methods", "POST, PUT, DELETE, GET, OPTIONS");

    var url = this.rootURL + '/Generic/GetRecentPosts';
    var ret = this.http.get<any>(url);
    return ret;

  }



}
